<template>
	<div class="view">
		<div class="tickets">
			<div class="column">
				<h2>Новые</h2>
				<TicketList :tickets="ticketsNew" />
			</div>
			<div class="column">
				<h2>В работе</h2>
				<TicketList :tickets="ticketsInProgress" />
			</div>
			<div class="column">
				<h2>Готово</h2>
				<TicketList :tickets="ticketsClosed" />
			</div>
		</div>
	</div>
</template>

<script>
import { API } from '@/config'
import CallList from '@/components/CallList'
import TicketList from '@/components/TicketList'
import Ticket from '@/components/Ticket'

export default {
	name: 'TicketsPage',
	components: {
		CallList,
		TicketList,
		Ticket,
	},
	data() {
		return {
			loading: false,
			roles: ['god', 'support', 'medic'],
		}
	},
	computed: {
		tickets() {
			return this.$store.getters.tickets
		},
		ticketsNew() {
			return this.tickets.filter(t => !t.closed && !t.assigned)
		},
		ticketsInProgress() {
			return this.tickets.filter(t => !t.closed && t.assigned)
		},
		ticketsClosed() {
			return this.tickets.filter(t => t.closed)
		},
	},
	methods: {
		async takeTicket(t) {
			let confirm = await this.$confirm('Берём этот тикет?')
			if (!confirm) return

			if (this.loading) return
			this.loading = true

			let { data } = await this.$http.post(API.TICKETS.take, { id: t.id })
			if (!data || data.err) {
				this.loading = false
				this.$notify(data.err)
				return
			}

			this.$store.commit('updateInArray', {
				path: 'chats',
				data: data.chat,
			})
			this.$store.commit('updateInArray', {
				path: 'tickets',
				data: data.ticket,
			})

			this.loading = false
			this.openTicket(t)
		},

		async takeCall(c) {
			let confirm = await this.$confirm('Берём этот звонок?')
			if (!confirm) return

			if (this.loading) return
			this.loading = true

			let { data } = await this.$http.post(API.CALLS.take, { id: c.id })
			if (!data || data.err) {
				this.loading = false
				this.$notify(data.err)
				return
			}

			this.loading = false
			this.$router.push('/calls/' + c.id)
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
	width: 100%;
	// padding: 0 20px;
}

.tickets {
	width: 98%;
	margin: 0 auto;
	padding-top: 20px;
	position: relative;
	display: flex;
	.column {
		width: 25%;
		padding: 0 1%;
		border-right: 2px solid rgba(0, 0, 0, 0.05);

		&:last-child {
			border: none;
		}
	}
}

.no-tickets {
	margin: 10px 0;
	opacity: 0.5;
	font-size: 15px;
}
</style>
